const usuario = state => state.usuario;
const autenticado = state => state.autenticado;

export default {
  usuario,
  autenticado,
}